let measurementCanvas = null

function measureTextNodeSize(node) {
    const text = node.content?.text ?? node.style?.text ?? ''
    const fontSize = node.style?.fontSize ?? 16
    const fontFamily = node.style?.fontFamily ?? 'Arial'
    const fallbackWidth = Math.max(fontSize, Math.ceil(String(text || ' ').length * fontSize * 0.6))
    const fallbackHeight = Math.max(fontSize, Math.ceil(fontSize * 1.2))

    if (typeof document === 'undefined') {
        return {width: fallbackWidth, height: fallbackHeight}
    }

    measurementCanvas ??= document.createElement('canvas')
    const context = measurementCanvas.getContext('2d')
    if (!context) {
        return {width: fallbackWidth, height: fallbackHeight}
    }

    context.font = `${fontSize}px ${fontFamily}`
    const metrics = context.measureText(text || ' ')
    const width = Math.max(fontSize, Math.ceil(metrics.width || fallbackWidth))
    const height = Math.max(
        fontSize,
        Math.ceil((metrics.actualBoundingBoxAscent ?? fontSize * 0.8) + (metrics.actualBoundingBoxDescent ?? fontSize * 0.2)),
    )

    return {width, height}
}

function getNodeSize(node) {
    const width = node.geometry?.width
    const height = node.geometry?.height

    if (Number.isFinite(width) && Number.isFinite(height)) {
        return {width, height}
    }

    if (node.type === 'text') {
        return measureTextNodeSize(node)
    }

    return {width: 0, height: 0}
}

export function placeNodeAtViewportCenter(node, viewportCenter) {
    if (!node?.geometry || !viewportCenter) return node

    const {width, height} = getNodeSize(node)

    return {
        ...node,
        geometry: {
            ...node.geometry,
            x: viewportCenter.x - width / 2,
            y: viewportCenter.y - height / 2,
        },
    }
}
